<template>
  <BoxWithTitle
    collapsible
    noPadding
    openingIcon="mdi-chevron-down"
    closingIcon="mdi-chevron-up"
    class="noBoxShadow"
  >
    <template #header>
      <div class="titleStyle">
        {{ $t('massBalance.coolingTowerSection.name') }}
      </div>
    </template>
    <template #content>
      <v-skeleton-loader
        v-if="loading"
        class="m-auto"
        type="table"
        transition="scale-transition"
      />
      <div class="contentStyle">
        <div class="contentStyleBtn">
          <v-btn
            class="siteTree-btn"
            color="secondary"
            @click="addMassBalance"
          >
            <v-icon
              color="#ffffff"
              left
            >
              mdi-plus
            </v-icon>
            {{ $t('administration.add') }}
          </v-btn>
        </div>
        <SearchWithFilters
          :withoutFilter="true"
          :searchPlaceholder="$t('laboratory.placeholder.labWoSearchBy')"
          :filterName="filterName"
        />
        <div
          v-if="massBalanceData.length > 0"
          class="contentStyleBody"
        >
          <div
            v-for=" (massBalance, index) in massBalanceData"
            :key="index"
          >
            <div
              class="contentStyleBodyEl"
            >
              <div class="rightContent">
                <div class="rightContentBorder" />
                <div class="d-flex align-center">
                  <v-icon
                    large
                    color="primary"
                  >
                    mdi-list-box-outline
                  </v-icon>
                </div>
                <div class="d-flex align-center rightContentText">
                  {{ massBalance.name }}
                </div>
              </div>
              <div class="leftContent">
                <v-menu offsetY>
                  <template #activator="{ on }">
                    <div class="d-flex align-center">
                      <v-btn
                        color="primary"
                        xSmall
                        fab
                        rounded
                        v-on="on"
                      >
                        <v-icon>
                          mdi-dots-vertical
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>

                  <v-list>
                    <!-- Edit -->
                    <ListItem
                      icon="mdi-pencil"
                      :title="$t('massBalance.editMassBalance')"
                      @click="updateMassBalance(massBalance.id)"
                    />
                    <!-- Delete -->
                    <ListItem
                      icon="mdi-delete"
                      :title="$t('massBalance.delete')"
                      titleColor="#EF4135"
                      color="#EF4135"
                      @click="deleteMassBalanceData(massBalance.id)"
                    />
                    <!-- E4 Settings -->
                    <ListItem
                      v-if="!massBalance.e4Cooling"
                      icon="mdi-plus"
                      :title="$t('massBalance.addE4Settings')"
                      @click="addE4Settings(massBalance.id)"
                    />
                    <ListItem
                      v-if="massBalance.e4Cooling"
                      icon="mdi-pencil"
                      :title="$t('massBalance.editE4Settings')"
                      @click="editE4Settings(massBalance.id)"
                    />
                    <ListItem
                      v-if="massBalance.e4Cooling"
                      icon="mdi-delete"
                      titleColor="#EF4135"
                      color="#EF4135"
                      :title="$t('massBalance.deleteE4Settings')"
                      @click="deleteE4Settings(massBalance.id)"
                    />
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="title text-center"
        >
          {{ $t('massBalance.coolingTowerSection.emptyMassBalance') }}
        </div>
      </div>
    </template>
  </BoxWithTitle>
</template>

<script>
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import SearchWithFilters from '@/components/shared/SearchWithFilters.vue';
import ListItem from '@/components/shared/widgets/ListItem.vue';
import MassBalanceForm from '@/views/sites/massBalance/MassBalanceForm.vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import { COOLING } from '@/aquassist-shared/constants/types/network';
import { TYPE_BLOWDOWN, TYPE_MAKE_UP } from '@/aquassist-shared/constants/types/flowMeters';
import E4SettingFormCooling from './E4Cooling/E4SettingFormCooling.vue';

export default {
    name: 'CoolingTowerComponent',
    components: {
        ListItem,
        BoxWithTitle,
        SearchWithFilters,
    },
    data() {
        return {
            loading: false,
            massBalanceData: [],
            filterName: 'coolingTower',
            queryParams: {},
            listAnalysis: [],
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'client',
            'team',
            'e4Config',
        ]),
    },

    async created() {
        await this.getMassBalanceData();
        await this.getAnalysis();
    },

    methods: {
        ...mapActions({
            resetMassBalanceData: ' resetMassBalanceData',
            setE4Config: 'setE4Config',
        }),
        async reload() {
            this.massBalanceData = [];
            await this.getMassBalanceData();
        },

        /* Ajouter un MassBalance depuis le gros bouton rouge "Ajouter" */
        async addMassBalance() {
            this.$root.$emit('showModal', {
                showNextPrevious: true,
                title: this.$t('massBalance.coolingTowerSection.add'),
                component: Vue.component('MassBalanceForm', MassBalanceForm),
                payload: {
                    sample: {
                        site: this.site.name,
                        client: this.client.name,
                    },
                    selection: [TYPE_MAKE_UP.toLowerCase(), TYPE_BLOWDOWN.toLowerCase()],
                    massBalanceType: COOLING,
                    analysisSelection: this.listAnalysis,
                },
                controlledValidation: true,
                resetData: this.resetMassBalanceData,
                onConfirm: async requestPayload => {
                    await this.addMassBalanceData(requestPayload);
                },
                width: 1000,
            });
        },

        /* Modifier un MassBalance */
        async updateMassBalance(massBalanceId) {
            const { data } = await this.$rq.getOneMassBalanceConfig(this.site.id, massBalanceId);
            this.$root.$emit('showModal', {
                showNextPrevious: true,
                title: this.$t('massBalance.coolingTowerSection.add'),
                component: Vue.component('MassBalanceForm', MassBalanceForm),
                payload: {
                    sample: {
                        site: this.site.name,
                        client: this.client.name,
                    },
                    massBalanceSelected: data,
                    selection: [TYPE_MAKE_UP.toLowerCase(), TYPE_BLOWDOWN.toLowerCase()],
                    massBalanceType: COOLING,
                    analysisSelection: this.listAnalysis,
                    isDisableModalHeader: false,
                },
                controlledValidation: true,
                resetData: this.resetMassBalanceData,
                onConfirm: async requestPayload => {
                    await this.editMassBalanceData(requestPayload, massBalanceId);
                },
                width: 1000,
            });
        },
        async getAnalysis() {
            const { data } = await this.$rq.getMassBalanceAnalysis(this.team.id, COOLING);
            this.listAnalysis = data.map(p => ({
                name: p.name,
                id: p?.id,
                measureUnit: p.measureUnit,
                key: p.key,
                displayOrder: p.displayOrder,
            })).sort((a, b) => a.displayOrder - b.displayOrder);
        },
        async addMassBalanceData(requestPayload) {
            const productData = [...requestPayload.products.data];
            const payload = {
                name: requestPayload.massBalanceStep.name,
                type: COOLING,
                reportUnit: requestPayload.massBalanceStep.reportUnit,
                flowmeters: requestPayload.flowMeters.data,
                analysis: requestPayload.analysis.newData,
                products: productData.map(p => ({
                    ...p,
                    ppm: Number(p.ppm),
                })),
            };
            await this.$rq.addAllMassBalanceConfig(this.site.id, payload);
            await this.reload();
        },
        async editMassBalanceData(requestPayload, massBalanceId) {
            const productData = [...requestPayload.products.data];
            const payload = {
                name: requestPayload.massBalanceStep.name,
                type: COOLING,
                reportUnit: requestPayload.massBalanceStep.reportUnit,
                flowmeters: requestPayload.flowMeters.data,
                analysis: requestPayload.analysis.newData,
                products: productData.map(p => ({
                    ...p,
                    ppm: Number(p.ppm),
                })),
            };
            await this.$rq.editOneMassBalanceConfig(this.site.id, massBalanceId, payload);
            await this.reload();
        },
        async getMassBalanceData() {
            this.loading = true;
            const { data } = await this.$rq.getAllMassBalanceConfig(this.site.id);
            this.massBalanceData = data.filter(p => (p.type === COOLING));
            this.loading = false;
        },
        async deleteMassBalanceData(massBalanceId) {
            this.$root.$emit('showModal', {
                title: this.$t('massBalance.coolingTowerSection.removeMassBalance'),
                component: Vue.component('ConfirmForm', ConfirmForm),
                payload: { msg: this.$t('massBalance.coolingTowerSection.removeMassBalance') },
                onConfirm: () => this.removeMassBalance(massBalanceId),
                isForm: false,
            });
        },
        async removeMassBalance(massBalanceId) {
            await this.$rq.deleteOneMassBalanceConfig(this.site.id, massBalanceId);
            await this.reload();
        },

        addE4Settings(massBalanceId) {
            this.$root.$emit('showModal', {
                showNextPrevious: true,
                title: this.$t('massBalance.addE4Settings'),
                payload: {
                    massBalanceName: this.massBalanceData[0].name,
                    isTemplate: this.isTemplate,
                },
                component: Vue.component('E4SettingsForm', E4SettingFormCooling),
                onConfirm: () => {
                    this.confirmE4Settings(massBalanceId);
                },
            });
        },
        async confirmE4Settings(massBalanceId) {
            const payload = {
                // InprovementInitiative
                projectDescription: this.e4Config.improvementInitiative.projectDescription,
                projectName: this.e4Config.improvementInitiative.projectName,
                waterSavingsUnit: this.e4Config.improvementInitiative.waterSavingsUnit,
                // Cooling Operating parameters
                temperatureUnit: this.e4Config.coolingOperatingParameters.temperatureUnit,
                hot: this.e4Config.coolingOperatingParameters.hot,
                cold: this.e4Config.coolingOperatingParameters.cold,
                // Baseline Data
                period: this.e4Config.baselineData.period,
                baselineYear: this.e4Config.baselineData.baselineYear,
                startMonth: this.e4Config.baselineData.startMonth,
                waterSavingBaselineOption: this.e4Config.baselineData.waterSavingBaselineOption,
                reportUnit: {
                    firstColumn: this.e4Config.baselineData.reportUnit.firstColumn,
                    secondColumn: this.e4Config.baselineData.reportUnit.secondColumn,
                },
                periodsMonths: this.e4Config.baselineData.periodsMonths,
            };
            await this.$rq.setE4CoolingConfig(this.site.id, massBalanceId, { e4Cooling: payload });

            this.$toasted.global.toast_success({
                message: this.$t('massBalance.e4SettingsSaved'),
            });
            this.reload();
        },

        async deleteE4Settings(massBalanceId) {
            this.$root.$emit('showModal', {
                title: this.$t('massBalance.deleteE4Settings'),
                component: Vue.component('ConfirmForm', ConfirmForm),
                payload: { msg: this.$t('massBalance.messageDeleteE4Settings') },
                onConfirm: () => this.deleteE4Config(massBalanceId),
                isForm: false,
            });
        },
        async deleteE4Config(massBalanceId) {
            await this.$rq.deleteE4Cooling(this.site.id, massBalanceId);
            await this.reload();
        },

        async editE4Settings(massBalanceId) {
            const { data } = await this.$rq.getE4Cooling(this.site.id, massBalanceId);
            const payload = {
                // InprovementInitiative
                improvementInitiative: {
                    projectDescription: data.projectDescription,
                    projectName: data.projectName,
                    waterSavingsUnit: data.waterSavingsUnit,
                },
                // Cooling Operating parameters
                coolingOperatingParameters: {
                    temperatureUnit: data.temperatureUnit,
                    hot: data.hot,
                    cold: data.cold,
                },
                // Baseline Data
                baselineData: {
                    period: data.period,
                    baselineYear: data.baselineYear,
                    startMonth: data.startMonth,
                    waterSavingBaselineOption: data.waterSavingBaselineOption,
                    reportUnit: {
                        firstColumn: data.reportUnit.firstColumn,
                        secondColumn: data.reportUnit.secondColumn,
                    },
                    periodsMonths: data.periodsMonths,
                },
            };

            this.setE4Config(payload);


            this.$root.$emit('showModal', {
                showNextPrevious: true,
                title: this.$t('massBalance.editE4Settings'),
                payload: {
                    editMode: true,
                },
                component: Vue.component('E4SettingsForm', E4SettingFormCooling),
                onConfirm: async () => {
                    this.confirmE4Settings(massBalanceId);
                },
            });
        },


    },

};

</script>

<style scoped lang="scss">
@import "@/assets/styles/massBalanceStyle.scss";
</style>
